import { render, staticRenderFns } from "./CharacterSheetProficiencies.vue?vue&type=template&id=5d995ce0&lang=pug&"
import script from "./CharacterSheetProficiencies.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetProficiencies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports